var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-flex",
    { attrs: { direction: "column", align: "stretch" } },
    [
      _c(
        "a",
        {
          staticClass: "professional-register",
          attrs: { href: "https://donamaid.com/seja-diarista-com-a-donamaid/" }
        },
        [
          _c("base-button", { attrs: { size: "large", outlined: "" } }, [
            _vm._v("sou diarista e quero fazer limpeza")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "base-button",
        {
          attrs: { size: "large" },
          on: {
            click: function($event) {
              _vm.setAccountableType("physical")
            }
          }
        },
        [_vm._v("quero limpeza na minha casa")]
      ),
      _vm._v(" "),
      _c(
        "base-button",
        {
          attrs: { size: "large" },
          on: {
            click: function($event) {
              _vm.setAccountableType("legal")
            }
          }
        },
        [_vm._v("quero limpeza na minha empresa")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76611360", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76611360","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUp/Main.vue
// module id = null
// module chunks = 